import { FC } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import store from './store';

import Routes from 'src/components/Routes';
import ErrorBoundaryComponent from 'src/hoc/ErrorBoundary';

import Analitics from './components/common/Analitics';
import './styles/index.scss';

const App: FC = () => {
  return (
    <Provider store={store}>
      <ErrorBoundaryComponent>
        <Analitics />
        <div className="wrapper">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          {/* <div className="announce">Web page start working since 1 of November</div> */}
          <Routes />
        </div>
      </ErrorBoundaryComponent>
    </Provider>
  );
};

export default App;
